<template>
  <div>
    <div class="body">
      <div class="profileData">
        <Custeom-Website-Contact-Card />
      </div>
      <!-- <Help-Menu></Help-Menu> -->
    </div>
  </div>
</template>

<script>
import CustomWebsiteContactCard from '@/components/customWebsite/CustomWebsiteContactCard.vue'
// import helpMenu from '@/components/help/Helpmenu.vue'
export default {
  name: 'LinkedinSingle',
  components: {
    'Custeom-Website-Contact-Card': CustomWebsiteContactCard
    // 'Help-Menu': helpMenu
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  padding: 40px 0 0;
}
ul {
  margin: 0;
  list-style-type: none;
  padding: 0;
  li {
    display: flex;
    width: 100%;
  }
}

.body {
  position: relative;
  // top: 51px;
  z-index: 0;
  .max-height {
    height: -webkit-fill-available;
  }
}
.blur-li {
  position: sticky;
  justify-content: center;
  bottom: 0px;
  background: rgba(255, 255, 255);
  -webkit-box-shadow: 0px -6px 20px 20px $white;
  box-shadow: 0px -6px 20px 20px $white;
  padding: 20px 0px 20px 0px;
  margin-top: 10px;
  button {
    padding: 14px;
    width: 80%;
    font-size: 16px;
  }
}
</style>
